import React from 'react';

type ActionVariant = 'primary' | 'secondary';

export interface LimitAlertAction {
  label: string;
  onClick: () => void;
  variant?: ActionVariant;
}

export interface LimitAlertProps {
  error?: Error;
  title?: string;
  message?: React.ReactNode;
  actions?: LimitAlertAction[];
  icon?: React.ReactNode;
}

export const LimitAlert: React.FC<LimitAlertProps> = ({
  error,
  title,
  message,
  actions,
  icon
}) => {
  if (!error) {
    return null;
  }

  const renderedActions = actions?.map((action, index) => {
    const variantClass = action.variant === 'primary' ? 'btn btn-primary btn-sm' : 'btn btn-outline-primary btn-sm';
    return (
      <button
        key={`${action.label}-${index}`}
        className={variantClass}
        onClick={action.onClick}
      >
        {action.label}
      </button>
    );
  });

  return (
    <div className="inline-error" role="alert">
      <div className="flex-grow-1">
        <p>{message ?? error.message}</p>
        {renderedActions && renderedActions.length > 0 && (
          <div className="d-flex gap-2 flex-wrap">
            {renderedActions}
          </div>
        )}
      </div>
    </div>
  );
};

export const UploadLimitAlert: React.FC<LimitAlertProps> = (props) => (
  <LimitAlert {...props} />
);

export const DownloadLimitAlert: React.FC<LimitAlertProps> = (props) => (
  <LimitAlert {...props} />
);

export type UploadLimitAlertAction = LimitAlertAction;
export type DownloadLimitAlertAction = LimitAlertAction;
